var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"vue-toast-manager_container",class:_vm.classesOfPosition,attrs:{"tag":"div","name":"vue-toast"}},_vm._l((_vm.toasts),function(toast,index){return _c('vue-toast',{key:toast.uid,attrs:{"message":toast.message,"options":toast.options,"onDestroy":toast.onDestroy,"position":index}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b22fe6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toast/toast.vue
// module id = null
// module chunks = 